
import React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { useDispatch } from 'react-redux';

import { ToolButton } from '../../../core';
import buttonCommandClick from './buttonCommandClick';

const ButtonCommandZoomOut = (props) => {

    const dispatch = useDispatch();
    const onClick = () => {
        buttonCommandClick(dispatch, 'ZOOM_OUT');
    }

    return (
        <IconButton
            className={ToolButton.TOOL_STYLE}
            iconProps={ToolButton.getIcon('Remove')}
            title="Oddálit"
            onClick={onClick}
        />
    );
}

export default ButtonCommandZoomOut;
